import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';


@autoinject()
export class DemoEssLogoPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

}
